export const aircraftData : string[] = [
    'Airplane (Single-Engine)',
    'Airplane (Multi-Engine)',
    'Glider',
    'Rotorcraft',
    'Seaplane',
    'Lighter Than Air'
]